import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { ticketApi } from '../services/TicketService';
import { dimensionApi } from '../services/DimensionService/dimensionApi';
import { teamApi } from '../services/TeamService';
import { recurringTaskApi } from '../services/RecurringTaskService';
import { workflowApi } from '../services/WorkflowService';
import { approvalApi } from '../services/ApprovalService';
import { reportingApi } from '../services/ReportingService';
import { assetApi } from '../services/AssetService/assetApi';
import { vendorApi } from '../services/VendorService';
import { complianceApi } from '../services/ComplianceService/complianceApi';
import { mobileReleaseApi } from '../services/MobileReleaseService';
import { userPreferencesApi } from '../services/UserPreferencesService';
import { featureFlagApi } from '../services/FeatureFlagService';
import { ticketReducer } from '../modules/tickets/state';
import { teamReducer } from '../modules/teams/state';
import { recurringTaskReducer } from '../modules/recurringTasks/state';
import { workflowReducer } from '../modules/workflows/state';
import { assetReducer } from '../modules/assets/state';
import { vendorReducer } from '../modules/vendors/state';
import { complianceReducer } from '../modules/compliance/state';

export const store = configureStore({
  reducer: {
    ticket: ticketReducer,
    team: teamReducer,
    recurringTask: recurringTaskReducer,
    workflow: workflowReducer,
    asset: assetReducer,
    vendor: vendorReducer,
    compliance: complianceReducer,
    [ticketApi.reducerPath]: ticketApi.reducer,
    [dimensionApi.reducerPath]: dimensionApi.reducer,
    [teamApi.reducerPath]: teamApi.reducer,
    [recurringTaskApi.reducerPath]: recurringTaskApi.reducer,
    [workflowApi.reducerPath]: workflowApi.reducer,
    [approvalApi.reducerPath]: approvalApi.reducer,
    [reportingApi.reducerPath]: reportingApi.reducer,
    [assetApi.reducerPath]: assetApi.reducer,
    [vendorApi.reducerPath]: vendorApi.reducer,
    [complianceApi.reducerPath]: complianceApi.reducer,
    [mobileReleaseApi.reducerPath]: mobileReleaseApi.reducer,
    [userPreferencesApi.reducerPath]: userPreferencesApi.reducer,
    [featureFlagApi.reducerPath]: featureFlagApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      ticketApi.middleware,
      dimensionApi.middleware,
      teamApi.middleware,
      recurringTaskApi.middleware,
      workflowApi.middleware,
      approvalApi.middleware,
      reportingApi.middleware,
      assetApi.middleware,
      vendorApi.middleware,
      complianceApi.middleware,
      mobileReleaseApi.middleware,
      userPreferencesApi.middleware,
      featureFlagApi.middleware
    ),
});

setupListeners(store.dispatch);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
